import { DARK_CONTROL } from '@flashka/shared/ui/styles/elevation';

/**
 * The chat input card's frame (glass, rounded, the soft drop) — shared by the
 * app's `ChatComposer` and the landing's agent-chat demo, so the demo cannot
 * drift from the composer it shows. A module of its own: the landing must not
 * pull the composer (and the chat's deck modal, dictation and analytics) into
 * its bundle.
 *
 * Dark: a CONTROL (elevation.ts) — the field you type into sits one clear step
 * above the surface holding it, wherever that is: the /chat canvas, the
 * floating chat's overlay shell, the deck's docked chat. Its dark rest border
 * is `secondary-300` — a quiet stroke the fill difference backs up; the field
 * s400 read far too bright on a card this large (review 2026-10). The
 * light frame's `secondary-50/80` mirrors to near-black in dark, which read
 * as a hole cut into every panel it sat in.
 */
export const CHAT_COMPOSER_FRAME_CLASS = `w-full rounded-3xl border border-secondary-100 bg-secondary-50/80 shadow-[0_5px_20px_0_rgba(0,0,0,0.08)] backdrop-blur-[7.5px] dark:border-secondary-300 ${DARK_CONTROL}`;
